import React from "react";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import db from "./Firebase";

const referrals = [
    {
        phone: "9045605852",
        name: "vishalsisodiya",
        username: "vishalsisodiya",
        referral_code: "nascom",
    },
    {
        phone: "9404459742",
        name: "pranavrajkumarbankar",
        username: "pranavrajkumarbankar",
        referral_code: "nascom",
    },
    {
        phone: "9496449502",
        name: "roshni",
        username: "roshni",
        referral_code: "nascom",
    },
    {
        phone: "9650680918",
        name: "aryanaryan",
        username: "aryanaryan",
        referral_code: "nascom",
    },
    {
        phone: "9711043928",
        name: "namitanamita",
        username: "namitanamita",
        referral_code: "nascom",
    },
];

const AppReferralSubmit = () => {
    const handleBulkSubmit = async () => {
        try {
            for (const refData of referrals) {
                await addDoc(collection(db, "app_referral"), {
                    ...refData,
                    created_date: serverTimestamp(),
                    status: "0",
                });
            }
            alert("✅ Referrals added successfully!");
        } catch (err) {
            console.error("❌ Error adding referrals: ", err);
            alert("❌ Error adding referrals. Check console.");
        }
    };

    return (
        <div style={{ padding: "20px" }}>
            <h2>Bulk Upload Referrals</h2>
            <p>This will add {referrals.length} referrals to Firestore.</p>
            <button
                onClick={handleBulkSubmit}
                style={{
                    padding: "10px 20px",
                    backgroundColor: "#4CAF50",
                    color: "white",
                    border: "none",
                    borderRadius: "5px",
                    cursor: "pointer",
                }}
            >
                Upload Referrals
            </button>
        </div>
    );
};

export default AppReferralSubmit;


// import { collection, addDoc, serverTimestamp } from "firebase/firestore";
// import db from "./Firebase";

// const referrals = [
//     {
//         phone: "9045605852",
//         name: "vishalsisodiya",
//         username: "vishalsisodiya",
//         referral_code: "nascom",
//     },
//     {
//         phone: "9404459742",
//         name: "pranavrajkumarbankar",
//         username: "pranavrajkumarbankar",
//         referral_code: "nascom",
//     },
//     {
//         phone: "9496449502",
//         name: "roshni",
//         username: "roshni",
//         referral_code: "nascom",
//     },
//     {
//         phone: "9650680918",
//         name: "aryanaryan",
//         username: "aryanaryan",
//         referral_code: "nascom",
//     },
//     {
//         phone: "9711043928",
//         name: "namitanamita",
//         username: "namitanamita",
//         referral_code: "nascom",
//     },
// ];

// export const AppReferralSubmit = async () => {
//     try {
//         for (const refData of referrals) {
//             await addDoc(collection(db, "app_referral"), {
//                 ...refData,
//                 created_date: serverTimestamp(),
//                 status: "0",
//             });
//         }
//         alert("Referrals added successfully!");
//     } catch (err) {
//         console.error("Error adding referrals: ", err);
//         alert("Error adding referrals. Check console.");
//     }
// };
